// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { N800 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// TODO: Just use semantic element
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RotationTitle = styled.h4({
	color: token('color.text.subtle', N800),
	font: token('font.body.small'),
	fontWeight: token('font.weight.bold'),
	margin: `${token('space.300', '24px')} 0 ${token('space.100', '8px')} 0`,
});
